@if (zichtbaar && uitleg()) {
    <div class="dl-node-dom-uitleg"
         [class.klikbaar]="!!uitlegVol()"
         [class.wordtzichtbaar]="wordtZichtbaar()"
         (pointerenter)="opPointerEnter()"
         (pointerleave)="opPointerLeave()"
         (click)="opKlik()">
        <div class="dl-node-dom-uitleg__html"
             [class.alleszichtbaar]="alleszichtbaar()"
             [innerHTML]="toonVol() ? uitlegVol() : uitleg()">
        </div>
    </div>
}
